import DeleteList from "./DeleteList";
export default DeleteList;
